export default "__VITE_ASSET__9oYvBMYD__"